import { useLazyQuery } from "@apollo/client/react";import React, { useMemo, useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import {
  Button, Grid } from
'@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { TextInput } from '../../../components/textInput/TextInput';
import { useDebounce } from '../../../hooks/useDebounce';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { GET_ALL_PROVEEDOR_DISTRIBUIDOR } from '../../../data/graphQL/queries/ProveedorDistribuidor/getAllProveedorDistribuidor';

import { CustomDialog } from '../../../components/customDialog/CustomDialog';

export const BuscarProveedor = ({ open, onClose, onRowClick }) => {

  const [
  rows,
  handleChangePaginationStatus,
  paginationStatus,
  totalCount,
  filterStatus,
  setFilterStatus] =
  useGetProveedores();

  const initialColumns = [
  {
    field: 'codigoSAP',
    headerName: 'Código'
  },
  {
    field: 'razonSocial',
    headerName: 'Razon Social'
  }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), []);

  const handleCloseDlgProveedor = () => {
    onClose();
  };

  return (
    <CustomDialog
      maxWidth="md"
      fullWidth
      open={open}
      onClose={onClose}
      title='Búsqueda de Proveedores'
      onCancel={handleCloseDlgProveedor}>
      
            <Grid
        container
        justifyContent={'space-between'}
        columns={{
          xs: 2
        }}
        marginBottom={1}>
        
 <Grid size={{ xs: 1 }}>
                    <TextInput
            placeholder='Filtrar'
            value={filterStatus}
            searchIcon
            onChange={(e) => setFilterStatus(e.target.value)}
            onClearButtonClick={() => setFilterStatus(' ')} />
          
                </Grid>
            </Grid>
            <Grid
        container
        justifyContent={'space-between'}
        columns={{
          xs: 2
        }}>
        
                <DataGridGenerico
          hideFooterPagination={false}
          toolbar={false}
          columns={columns}
          rows={rows}
          onPageChange={(page) =>
          handleChangePaginationStatus((prev) => ({
            ...prev,
            page: page
          }))
          }
          onPageSizeChange={(pageSize) =>
          handleChangePaginationStatus((prev) => ({
            ...prev,
            pageSize: pageSize,
            page: 0
          }))
          }
          pageSize={paginationStatus.pageSize}
          totalCount={totalCount}
          currentPage={paginationStatus.page}
          onRowClick={onRowClick} />
        
            </Grid>
        </CustomDialog>);

};


const useGetProveedores = () => {
  const [proveedores, setProveedores] = useState([]);

  const [paginationStatus, setPaginationStatus] = useState({
    pageSize: 5,
    page: 0
  });

  const [filterStatus, setFilterStatus] = useState('');
  const debouncedFilterValue = useDebounce(filterStatus, 1000);

  const [getProveedores, { data: proveedoresData, loading: proveedoresLoading }] = useLazyQuery(GET_ALL_PROVEEDOR_DISTRIBUIDOR, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!proveedoresData) return;
    setProveedores(proveedoresData);
  }, [proveedoresData]);

  useEffect(() => {
    if (!proveedoresLoading) {
      getProveedores({
        variables: {
          skip: paginationStatus.page * paginationStatus.pageSize,
          take: paginationStatus.pageSize,
          where: {
            or: [
            { codigoSAP: { contains: debouncedFilterValue } },
            { razonSocial: { contains: debouncedFilterValue } }]

          }
        }
      });
    }
  }, [paginationStatus, debouncedFilterValue]);
  return [
  proveedores?.allProveedorDistribuidor?.items || [],
  setPaginationStatus,
  paginationStatus,
  proveedores?.allProveedorDistribuidor?.totalCount,
  filterStatus,
  setFilterStatus];

};